import { vuexTypes } from '../types'

import { tokensService } from '@api/tokens.service'
import { RecordFactory } from '@js/records/factory'
import { StateHelper } from '../helpers/state.helper'

function getInitialState () {
  return {
    tokens: [],
    userOwnedTokens: [],
    acquired_tokens: [],
    currentAsset: ''
  }
}

function resetState (state) {
  const initialState = getInitialState()
  Object.keys(state).forEach(key => {
    if (Object.keys(initialState).indexOf(key) === -1) {
      delete state[key]
    }
  })
  Object.assign(state, initialState)
}

export const state = getInitialState()

export const mutations = {
  SET_LOGGED_OUT_STATE (state) {
    resetState(state)
  },
  SET_ALL_TOKENS: (state, tokens) => {
    state.tokens = tokens
  },
  SET_USER_OWNED_TOKENS: (state, tokens) => {
    state.user_tokens = tokens
  },
  SET_USER_ACQUIRED_TOKENS: (state, tokens) => {
    state.acquired_tokens = tokens
  },
  SET_CURRENT_ASSET: (state, code) => {
    state.currentAsset = code
  }
}

export const actions = {
  async GET_ALL_TOKENS ({ commit }) {
    commit(vuexTypes.SET_ALL_TOKENS, (await tokensService.loadTokens()).filter(val => val.details !== null).map(record => RecordFactory.createTokenRecord(record)))
  },
  COMMIT_CURRENT_ASSET: ({ commit }, asset) => {
    commit(vuexTypes.SET_CURRENT_ASSET, asset)
  }
}

export const getters = {
  tokens: state => state.tokens.sort((a, b) => a.code > b.code ? 1 : -1),
  walletTokens: state => state.tokens.filter(token => token.isWalletToken),
  userOwnedTokens: state => state.userOwnedTokens,
  currentAsset: state => state.currentAsset,
  userAcquiredTokens: _ => StateHelper.deriveTokensFromBalancesDetails(),
  userWalletTokens: _ => StateHelper.deriveTokensFromBalancesDetails(token => token.isWalletToken),
  userTransferableTokens: _ => StateHelper.deriveTokensFromBalancesDetails(token => token.isTransferable),
  userWithdrawableTokens: _ => StateHelper.deriveTokensFromBalancesDetails(token => token.isWithdrawable),
  userCashTokens: _ => StateHelper.deriveTokensFromBalancesDetails(token => token.isCash),
  statsQuoteToken: _ => StateHelper.deriveTokensFromBalancesDetails(token => token.isStatsQuote)
}

export default {
  actions,
  getters,
  mutations,
  state
}



// WEBPACK FOOTER //
// ./src/vuex/modules/tokens.module.js